import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Icons,
} from '@commenda/kakashi';

interface SalesTaxProductConfirmationModalProps {
  isConfirmationModalOpen: boolean;
  setIsConfirmationModal: (isTwoFactorModalOpen: boolean) => void;
  title: string;
  message: string;
  handleConfirmation: () => void;
}

const SalesTaxProductConfirmationModal = ({
  isConfirmationModalOpen,
  setIsConfirmationModal,
  title,
  message,
  handleConfirmation,
}: SalesTaxProductConfirmationModalProps) => {
  return (
    <Dialog
      open={isConfirmationModalOpen}
      onOpenChange={setIsConfirmationModal}
    >
      <DialogContent className="bg-white">
        <DialogHeader className="flex items-start border-0 py-6 gap-2">
          <div className="bg-bg-success flex items-center shrink-0 justify-center h-12 w-12 rounded-lg">
            <Icons.CheckCircle className="text-text-success h-5 w-5" />
          </div>
          <div className="flex flex-col  w-full items-start">
            <h3 className="text-text-primary txt-large-bold">{title}</h3>
            <p className="txt-small-regular text-text-tertiary">{message}</p>
          </div>
        </DialogHeader>

        <DialogFooter className="py-0 pb-6 border-0">
          <Button variant="secondary" onClick={handleConfirmation}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SalesTaxProductConfirmationModal;
